const validated = (formInputObject, validations) =>
    ({...formInputObject, validations })

export default validated
